import {
  createRouter,
  createWebHistory
} from 'vue-router'

import main from '../components/main/main.vue';
import list from '../components/list/list.vue';
import classList from '../components/class-list/class-list.vue';
import warning from '../components/warning/warning.vue';
import personCenter from '../components/person-center/person-center.vue';

const routes = [
  {
    path: '/:type',
    component: main,
    children: [
      { path: 'classList', component: classList },
      { path: 'list/:classId', component: list },
      { path: 'warning', component: warning },
      { path: 'person-center', component: personCenter },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router